import(/* webpackMode: "eager", webpackExports: ["RegisterForm"] */ "/vercel/path0/app/(auth)/register/register-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
